export default __webpack_public_path__ + "static/media/New-Baer-Article.a9da2a5e.pdf";